import { View } from '@react-pdf/renderer';
import * as React from 'react';

interface WpdfViewProps extends React.ClassAttributes<any> {
    pdf?: boolean;
    style?: React.CSSProperties | any;
    onClick?: () => void;
    refElement?: (ref: any) => void;
    nowrap?: boolean;
    break?: boolean;
}

export class WpdfView extends React.Component<WpdfViewProps, {}> {

    constructor(props: any) {
        super(props);
    }

    render(): JSX.Element {
        return this.props.pdf ?
            <View
                style={this.props.style}
                wrap={!(this.props.nowrap || false)}
                break={this.props.break || false}
            >
                {this.props.children}
            </View>
            :
            <div
                ref={this.props.refElement}
                style={this.props.style}
                onClick={this.props.onClick}
            >
                {this.props.children}
            </div>;
    }
}
